// This is a replacement for `RxDBHandler` in `src/rxdb/useRxDB.tsx`.
import postal from 'postal';
import { FC, useEffect, useMemo } from 'react';
import { Provider } from 'rxdb-hooks';

import { RxDBContext } from '@/rxdb/replication-v1/RxDBContext';

import { useReplication } from '../useReplication';
import { IRxdbManager } from './IRxdbManager';
import { useSyncCheck } from './useSyncCheck';
import { useSyncTimeSaver } from './useSyncTimeSaver';

export interface Props {
  manager: IRxdbManager;
}

// This is the V2 replacement for `RxDBHandler` from 'src/rxdb/useRxDB'
export const LegacyRxdbManagerHandler: FC<Props> = props => {
  useSyncTimeSaver();
  useSyncCheck();

  const replication = useReplication();
  const active = useMemo(() => !!replication, [replication]);
  useEffect(() => {
    postal.publish({
      channel: 'sync',
      topic: 'sync.online',
    });
  }, [active]);

  return (
    <RxDBContext.Provider value={{ db: props.manager }}>
      <Provider db={props.manager.db}>{props.children}</Provider>
    </RxDBContext.Provider>
  );
};
